import server from '../utils/server';

export function dataAccessPoliciesState(
  state = {
    dataAccessPolicies: [],
    dataAccessPoliciesByRoleId: {},
    loading: false,
  },
  action
) {
  switch (action.type) {
    case 'RECEIVED_DATA_ACCESS_POLICIES': {
      return { ...state, dataAccessPolicies: action.value, loading: false };
    }

    case 'STARTED_LOADING_DATA_ACCESS_POLICIES_BY_ROLE_ID': {
      return { ...state, loading: true };
    }

    case 'RECEIVED_DATA_ACCESS_POLICIES_BY_ROLE_ID': {
      return {
        ...state,
        dataAccessPoliciesByRoleId: action.value,
        loading: false,
      };
    }
    default: {
      return state;
    }
  }
}

export const getAllDataAccessPolicies = () => async dispatch => {
  const data = await server.get('/api/v1/data_access_policies/options');
  dispatch({
    type: 'RECEIVED_DATA_ACCESS_POLICIES',
    value: data,
  });
};

export const getDataAccessPoliciesByRoleId =
  (roleId: number) => async dispatch => {
    if (roleId) {
      dispatch({ type: 'STARTED_LOADING_DATA_ACCESS_POLICIES_BY_ROLE_ID' });
      const params = { role_id: roleId };
      const data = await server.get('/api/v1/data_access_policies', {
        ...params,
      });
      dispatch({
        type: 'RECEIVED_DATA_ACCESS_POLICIES_BY_ROLE_ID',
        value: data,
      });
    }
  };
